import { Injectable } from '@angular/core';
import { MineOrdersSubGQL } from '@ui/orders/graphql';
import { OrganizationService } from 'ZalamoLibrary/src/lib/core/organizations/organization.service';
import { Apollo } from 'apollo-angular';
import { combineLatest, switchMap, tap } from 'rxjs';
import {
  GetMineScheduleEventsGQL,
  GetMineScheduleEventsQuery,
  ScheduleEventAddedGQL,
  ScheduleEventUpdatedGQL,
} from '@ui/booking/graphql';

@Injectable({
  providedIn: 'root',
})
export class BookingSubscriptionsService {
  constructor(
    private sub: MineOrdersSubGQL,
    private organizations: OrganizationService,
    private apollo: Apollo,
    private getMineScheduleEventsGQL: GetMineScheduleEventsGQL,
    private scheduleEventAddedGQL: ScheduleEventAddedGQL,
    private scheduleEventUpdatedGQL: ScheduleEventUpdatedGQL,
  ) {}

  subToScheduleEvents() {
    this.organizations
      .getCurrentOrganization()
      .pipe(
        switchMap((organizationId) =>
          combineLatest([
            this.scheduleEventUpdatedGQL.subscribe({
              variables: { organizationId },
            }),
            this.scheduleEventAddedGQL
              .subscribe({ variables: { organizationId } })
              .pipe(
                tap(({ data: { scheduleEventAdded } }) => {
                  const variables = {
                    organizationId,
                  };
                  const config = {
                    query: this.getMineScheduleEventsGQL.document,
                    variables,
                  };
                  const res =
                    this.apollo.client.readQuery<GetMineScheduleEventsQuery>(
                      config,
                    );
                  if (
                    !!res &&
                    !res?.getAllScheduleEventsForUser.find(
                      (e) =>
                        e.scheduleEventId ===
                        scheduleEventAdded.scheduleEventId,
                    )
                  ) {
                    this.apollo.client.writeQuery({
                      ...config,
                      data: {
                        ...res,
                        getAllScheduleEventsForUser: [
                          ...res.getAllScheduleEventsForUser,
                          scheduleEventAdded,
                        ],
                      },
                    });
                  }
                }),
              ),
          ]),
        ),
      )
      .subscribe();
  }
}
